import useUiStore from './useUiStore'
import { makeStyles } from '@material-ui/core'

/**
 * Styles for the app container that handles shifting the
 * page content out of the way so the info panel can be shown
 */
export const useContainerStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 10,
    transition: `width 
    ${theme.transitions.duration.short}ms 
    ${theme.transitions.easing.easeInOut}`,
    height: '100%',
    pointerEvents: 'all',
    touchAction: 'none',
    width: `calc(100% - ${theme.app.panelWidth}px)`,
    [theme.breakpoints.down('sm')]: {
      width: '100vw'
    }
  }
}))

export default useUiStore
export { useShowInfo } from './useUiStore'
